'use client';

import Class from '@icons/Class.svg';
import Info from '@icons/Info.svg';

import { InformationFieldContainer } from '@components/InformationField/styles';
import { Text } from '@components/TextGroups';

interface InformationFieldProps {
  text: string;
  variant?: 'info' | 'secondSubstitute';
}

/**
 * Information filed with the background
 */
export const InformationField = ({ text, variant = 'info' }: InformationFieldProps) => {
  return (
    <InformationFieldContainer>
      {variant === 'info' ? <Info /> : <Class />}
      <Text>{text}</Text>
    </InformationFieldContainer>
  );
};
